import { IconProps } from "./IconProps";

export function ExclamationCircle(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm2 26h-4v-4h4zm0-6h-4V6h4zm0 0"></path>
    </svg>
  );
}
